import { useCanManageWorkspace } from "@hooks/permissions/useCanManageWorkspace";
import { useTypedFlags } from "@hooks/useTypedFlags";

export function useCanManageCounterpartyTin(): boolean {
    const { counterpartyTinVault } = useTypedFlags();
    const canManageWorkspace = useCanManageWorkspace();
    return counterpartyTinVault && canManageWorkspace;
}
